module.exports = "\n<sa-page-header></sa-page-header>\n\n \n\n<router-outlet></router-outlet>\n\n<sa-page-footer></sa-page-footer>"